"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiMooDropBold = function IconUiMooDropBold(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M24 44.015a13.46 13.46 0 0 1-8.86-3.133 15.619 15.619 0 0 1-1.165-1.055 13.649 13.649 0 0 1-4.135-9.973 13.565 13.565 0 0 1 1.713-6.764c.067-.137.339-.681 11.151-19.259a1.5 1.5 0 0 1 2.592 0C36.108 22.409 36.38 22.953 36.483 23.158a13.478 13.478 0 0 1 1.677 6.7 13.65 13.65 0 0 1-4.136 9.974 13.643 13.643 0 0 1-8.5 4.129c-.519.039-1.012.054-1.524.054zm0-36.448c-7.75 13.322-9.627 16.6-9.8 16.935a10.681 10.681 0 0 0-1.359 5.352 10.612 10.612 0 0 0 3.259 7.853 12.809 12.809 0 0 0 .952.861A10.411 10.411 0 0 0 24 41.015q.651 0 1.254-.046a10.565 10.565 0 0 0 6.646-3.253 10.623 10.623 0 0 0 3.265-7.862 10.592 10.592 0 0 0-1.325-5.287c-.212-.401-2.09-3.678-9.84-17z"
  }));
};

IconUiMooDropBold.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiMooDropBold;
exports.default = _default;